var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { FTLObjectUtils } from "ftl-core";
import { useCallback, useEffect, useRef, useState } from "react";
import FTLFixedSizeList from "./FTLFixedSizeList";
import InfiniteLoaderWrapper from "react-window-infinite-loader";
export default (_a) => {
    var _b;
    var { itemSize = 32, records = 10, itemCount: itemCountFromProps, getItemKey, children, asyncData } = _a, otherProps = __rest(_a, ["itemSize", "records", "itemCount", "getItemKey", "children", "asyncData"]);
    const infiniteLoaderRef = useRef(null);
    const [loaded, setLoaded] = useState(false);
    const [lastRequest, setLastRequest] = useState({
        offset: (_b = asyncData === null || asyncData === void 0 ? void 0 : asyncData.state.offset) !== null && _b !== void 0 ? _b : 0,
        limit: 0,
        query: (asyncData === null || asyncData === void 0 ? void 0 : asyncData.query) || "",
    });
    let itemCount = itemCountFromProps || (asyncData && asyncData.state.count) || 0;
    itemCount = loaded || !asyncData ? itemCount : itemCount + 1;
    const height = itemCount < records ? itemCount * itemSize : (records / 2) * itemSize;
    const width = otherProps.width || "100%";
    const loadNextPage = asyncData
        ? useCallback((startIndex, stopIndex) => __awaiter(void 0, void 0, void 0, function* () {
            const { state, query, loadItems } = asyncData;
            const prevResultOffset = ((lastRequest.offset || lastRequest.limit) &&
                lastRequest.offset + lastRequest.limit) ||
                records;
            if (prevResultOffset < startIndex) {
                const newOffset = state.offset >= startIndex ? state.offset : startIndex;
                const stopIndexLimit = stopIndex - newOffset;
                const newRequest = {
                    offset: prevResultOffset,
                    limit: stopIndexLimit > newOffset - prevResultOffset
                        ? stopIndexLimit + 1
                        : newOffset - prevResultOffset + 1,
                    query,
                };
                if (!FTLObjectUtils.compare(newRequest, lastRequest)) {
                    setLastRequest(newRequest);
                    yield loadItems(newRequest);
                }
            }
        }), [asyncData])
        : null;
    const isItemLoaded = (index) => {
        return loaded || index <= ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.state.items.length) || 0);
    };
    useEffect(() => {
        if ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.state.count) && (asyncData === null || asyncData === void 0 ? void 0 : asyncData.state.items))
            if ((asyncData === null || asyncData === void 0 ? void 0 : asyncData.state.count) <= (asyncData === null || asyncData === void 0 ? void 0 : asyncData.state.items.length))
                setLoaded(true);
            else
                setLoaded(false);
    }, [asyncData === null || asyncData === void 0 ? void 0 : asyncData.state.items.length, lastRequest.count]);
    useEffect(() => {
        if (asyncData && asyncData.state.offset === 0) {
            setLoaded(false);
            setLastRequest({
                offset: 0,
                limit: 0,
                query: asyncData.query,
            });
        }
    }, [asyncData === null || asyncData === void 0 ? void 0 : asyncData.state.offset]);
    return asyncData ? (React.createElement(InfiniteLoaderWrapper, { ref: infiniteLoaderRef, isItemLoaded: isItemLoaded, itemCount: itemCount, loadMoreItems: loadNextPage, threshold: records / 2 }, ({ onItemsRendered, ref }) => !asyncData.state.loading ? (React.createElement(FTLFixedSizeList, { ref: ref, itemCount: itemCount, onItemsRendered: onItemsRendered, getItemKey: getItemKey, initialScrollOffset: otherProps.initialScrollOffset, itemSize: itemSize, width: width, height: height }, children)) : (asyncData.loadingText))) : (React.createElement(FTLFixedSizeList, { itemCount: itemCount, getItemKey: getItemKey, initialScrollOffset: otherProps.initialScrollOffset, itemSize: itemSize, width: width, height: height }, children));
};
//# sourceMappingURL=FTLInfiniteLoader.js.map